export const translation_en = {
    "welcome": "Welcome to our website",
    "description": "This is an i18n example.",
    "alertMessage":"Wrong answer please select again",
    "tasks":{
      "active_tab":"Active",
      "inreview_tab":"In Review",
      "completed_tab":"Completed"
    },
    "taskdetaitls":{
      "educational":{
        "type":"Educational",
        "note_label":"Note:",
        "note":"Note: Watch the video carefully to complete the quiz",
        "note1":"Note: Watch the video carefully and navigate accordingly to complete the task",
        "start_btn":"Start the Quiz",
        "question_lable":"Qusetion",
        "quest_submit_btn":"Submit",
        "attempts":"Attempts Left",
        "next_btn":"Next",
        "result_btn":"Submit ",
        "try_again_btn":"Try Again",
        "result":{
          "message_positive":"Congratulations! You earned",
          "sub_message_feedback":"Thank you for your Feedback",
          "message_feedback":"Congratulations! The task is completed.",
          "message_negative":"You are low on points! Please start any task",
          "question_answered":"Questions Answered correctly",
          "point_balance":"pts Balance",
          "go_to_home":"Go to Home"
        }
      },
      "watch_videos":{
        "type":"WatchVideo",
        "note_label":"Note:",
        "note":"Note: Watch the video carefully to complete the quiz",
        "note1":"Note: Watch the video carefully and navigate accordingly to complete the task",
        "start_btn":"Start the Quiz",
        "question_lable":"Qusetion",
        "quest_submit_btn":"Go to Point History",
        "attempts":"Attempts Left",
        "next_btn":"Next",
        "result_btn":"Submit ",
        "try_again_btn":"Try Again",
        "result":{
          "message":"Thank you completing the task.",
          "sub_message":"It is currently in review and {{points}} points will be credited upon navigating as per the video.",
          "go_to_home":"Go to Point History",
          "check_status":"Check Task Status"
        }
      },
      "feedback":{
        "type":"Feedback",
        "note_label":"Note:",
        "notlikely":"Not likely",
        "extlikely":"Extremely likely",
        "note":"Note: Watch the video carefully to complete the quiz",
        "start_btn":"Start the Quiz",
        "question_lable":"Qusetion",
        "quest_submit_btn":"Submit",
        "attempts":"Attempts Left",
        "next_btn":"Next",
        "result_btn":"Submit ",
        "try_again_btn":"Try Again",
        "result":{
          "message_positive":"Congratulations! You earned",
          "message_negative":"You are low on points! Please start any task",
          "question_answered":"Questions Answered correctly",
          "point_balance":"pts Balance",
          "go_to_home":"Go to Home"
        }
      },
      "competition":{
        "type":"Competition",
        "note_label":"Note:",
        "note":"Note: Watch the video carefully to complete the quiz",
        "start_btn":"Start the Quiz",
        "question_lable":"Qusetion",
        "quest_submit_btn":"Submit",
        "attempts":"Attempts Left",
        "next_btn":"Next",
        "result_btn":"Submit ",
        "try_again_btn":"Try Again",
        "result":{
          "message_positive":"Congratulations! You earned",
          "message_negative":"You are low on points! Please start any task",
          "question_answered":"Questions Answered correctly",
          "point_balance":"pts Balance",
          "go_to_home":"Go to Home"
        }
      },
      "dot_code_scanning":{
        "note_label":"Note:",
        "note":"{{points}} points will be credited only on task completion",
        "initnote":"Scan 1 pack each of the given variants to earn points",
        "type":"DotCodeScanning",
        "label":"Pack scanned - {{completedSteps}}/{{totalSteps}}",
        "sample_img_label":"Sample Image",
        "step_label":"Instruction",
        "watch_now":"Watch video",
        "submit":"Start the task",
        "picture":"Picture",
        "monthly_ins":"Instruction",
        "monthly_submit":"Scan Pack To Earn Points",
        "monthly_note":"Please click on the button below to scan up to 50 packs",
        "scan_earn":"Scan & Earn",
        "month_target":"Monthly Target",
        "points_earned_month":"Points Earned",
        "list_of_variants":"List of Variants",
        "days_left_month":"left"
      },
      "availability":{
        "type":"Availability",
        "uploading":"Uploading...",
        "take_photo_btn":"Take a Picture",
        "retake_photo_btn":"Retake",
        "submit":"Submit",
        "continue":"continue",
        "step_label":"Step",
        "sample_img_label":"Sample Image",
        "clicked_img_label":"Clicked Image",
        "picture":"Picture",
        "result":{
          "message":"Thank you completing the task.",
          "sub_message":"It is currently in review and {{points}} points will be credited shortly",
          "go_to_home":"Go to Home",
          "check_status":"Check Task Status"
        }
      },
      "image_recogx":{
        "type":"ImageRecognize",
        "uploading":"Uploading...",
        "take_photo_btn":"Take a Picture",
        "retake_photo_btn":"Retake",
        "submit":"Submit",
        "step_label":"Step",
        "sample_img_label":"Sample Image",
        "clicked_img_label":"Clicked Image",
        "picture":"Picture",
        "result":{
          "message":"Thank you completing the task.",
          "sub_message":"It is currently in review and {{points}} points will be credited shortly",
          "go_to_home":"Go to Home",
          "check_status":"Check Task Status"
        }
      },
      "buildstick":{
        "type":"BuildStick",
        "note_label":"Note:",
        "note":"Drag and drop the correct flavour to the highlighted area on the stick.",
        "note1":"Note: Watch the video carefully and navigate accordingly to complete the task",
        "start_btn":"Start the Quiz",
        "question_lable":"Qusetion",
        "quest_submit_btn":"Submit",
        "attempts":"Attempts Left",
        "next_btn":"Next",
        "result_btn":"Submit ",
        "try_again_btn":"Try Again",
        "alertErrorMessage":"Wrong flavour selected",
        "alertSuccessMessage":"Correct flavour selected",
        "result":{
          "message_positive":"Congratulations! You earned",
          "message_negative":"You are low on points! Please start any task",
          "question_answered":"Questions Answered correctly",
          "point_balance":"pts Balance",
          "go_to_home":"Go to Home"
        }
      },
      "clicklink":{
        "type":"clickLink",
        "download1":"Google Play Store",
        "download2":"App Store",
        "quest_submit_btn":"I confirm that I downloaded the app",
        "next_btn":"Next",
        "note":"This app is important for upcoming tasks. Thank you!",
        "result":{
          "message_positive":"Congratulations! You earned",
          "message_negative":"You are low on points! Please start any task",
          "question_answered":"Questions Answered correctly",
          "point_balance":"pts Balance",
          "go_to_home":"Go to Home"
        }
      },
      "hold_on_title":"Hold on!",
      "hold_on_message":"Are you sure you want to leave the task? You will lose all progress",
      "hold_on_yes":"Yes",
      "hold_on_no":"No"
    },
    "earn_pnts": {
       "points_earned": "Earn {{points}} pts",
       "points_earned_top": "Earn {{points}}",
       "points_earned_diwali": "Earn Task {{points}} + Bonus {{bonus}} pts",
       "points_earn": "Earn {{points}} pts",
       "rupee_credited": "{{amount}} credited",
       "points_earn_diwali": "Earn Task {{points}} + Bonus {{bonus}} pts",
       "points_cridited":"pts credited",
       "points_earns" :"pts Earned",
       "credited_on":"Credited on"
     },
     "status_type":{
      "review":"In Review",
      "status_review":"Status - In Review"
     },
     "profile":{
      "profile_heading":"You're a star retailer, ranking among the top 20 in your city!"
     },
     "days_left": {
      "one": " day left",
      "other": " days left"
      },
     "task_names":{
      "start_the_task":"Start The Task",
      
      "loading":"loading...",
      "restart_the_task":"Restart The Task",
      "start_the_quiz":"Start the Quiz",
      "expired":"Expired",
      "resume_task":"Resume Task",
      "in_review":"In Review",
     },
     "rewards":{
      "title":"Rewards and Vouchers",
      "sub_title":"Complete your tasks and unlock exciting vouchers and gifts!",
      "view_all_reward":"View Rewards & Vouchers"
     },
     "task":"Task",
     "diwali_points":{
       "congratulations_title":"Congratulations! The Deepawali Dhamaka task is completed.",
       "in_review":"Status - In Review",
       "task_pts":"Task pts:",
       "bonus_pts":"Bonus pts :",
       "bonus_pts_text":"Task {{task_points}} + Bonus {{bonus_pts}} will be credited upon review completion.",
      "points_earned": "Earn pts"
     },
     "day_left": "day left",
      "days_lefts": "days left",
      "hour_left": "hr",
      "hours_left": "hrs",
      "expired": "expired",
      "totol_points_earned":"Total Earned",
      "total_redeemed":"Total Redeemed",
      "pts":"pts",
      "transactions":"Transactions",
      "months":"months",
      "results_from_last":"Results from last",
      "filter_by_month":"Filter by Month",
      "select_year":"Select Year",
      "select_month":"Select Month",
      "apply_text":"Apply",
      "okay_text":"Okay!",
      "transactions_popup":{
        "note":"Note",
        "earned_points_valid_till":"Earned points valid till",
        "answered_correctly":"Answered correctly",
        "questions":"Questions",
        "points_earned":"Points Earned"
     },
     "varients":"Variants",
    "status":"Status",
     "uh_no_resubmit":"Uh Oh! The task needs to be done again.",
    "picture":"Picture",
    "or":"or",
    "rejected":"rejected",
     "reason":"Reason"
  }